import { PAYMENT_DETAILS_FAILED, PAYMENT_DETAILS_LOADED, PAYMENT_DETAILS_LOADING } from '../../reducers/paymentSummaryReducers';
import { PAYMENT_SUMMARY } from '../../utils/Links';

export const fetchPaymentSummary = params => ({
  initiate: PAYMENT_DETAILS_LOADING,
  failure: PAYMENT_DETAILS_FAILED,
  loaded: PAYMENT_DETAILS_LOADED,
  urlName: PAYMENT_SUMMARY,
  params,
});
